import { useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;

const GoogleMark = () => (
  <svg viewBox="0 0 24 24" className="h-4.5 w-4.5 h-[18px] w-[18px]" aria-hidden="true">
    <path
      fill="#EA4335"
      d="M12 5.04c1.62 0 3.06.56 4.2 1.64l3.12-3.12C17.46 2.09 14.96 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84C6.71 7.31 9.14 5.04 12 5.04z"
    />
    <path
      fill="#4285F4"
      d="M23.5 12.27c0-.79-.07-1.54-.19-2.27H12v4.51h6.47c-.29 1.48-1.14 2.73-2.4 3.58l3.66 2.84C21.85 19.04 23.5 15.94 23.5 12.27z"
    />
    <path
      fill="#FBBC05"
      d="M5.84 14.09A7.06 7.06 0 0 1 5.46 12c0-.73.13-1.43.38-2.09L2.18 7.07A11 11 0 0 0 1 12c0 1.77.43 3.45 1.18 4.93l3.66-2.84z"
    />
    <path
      fill="#34A853"
      d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.66-2.84c-.98.66-2.23 1.06-3.62 1.06-2.86 0-5.29-2.27-6.16-5.47l-3.66 2.84C3.99 20.53 7.7 23 12 23z"
    />
  </svg>
);

const AppleMark = () => (
  <svg viewBox="0 0 24 24" className="h-[18px] w-[18px] fill-current" aria-hidden="true">
    <path d="M17.05 12.54c-.03-2.89 2.36-4.27 2.47-4.34-1.35-1.97-3.44-2.24-4.18-2.27-1.78-.18-3.47 1.05-4.37 1.05-.9 0-2.29-1.02-3.77-1-1.94.03-3.72 1.13-4.72 2.86-2.01 3.49-.51 8.66 1.45 11.49.96 1.39 2.1 2.94 3.6 2.88 1.45-.06 2-.93 3.74-.93s2.24.93 3.77.9c1.56-.03 2.55-1.41 3.5-2.8 1.1-1.61 1.55-3.17 1.58-3.25-.04-.02-3.03-1.16-3.07-4.59zM14.16 4.06c.8-.97 1.34-2.31 1.19-3.65-1.15.05-2.55.77-3.38 1.74-.74.85-1.39 2.23-1.22 3.54 1.29.1 2.6-.65 3.41-1.63z" />
  </svg>
);

const socialButtonClass =
  "group inline-flex w-full items-center justify-center gap-2.5 rounded-full border border-white/15 bg-ink/50 px-7 py-3 text-sm font-bold text-paper transition-[border-color,background-color,transform] duration-200 hover:-translate-y-0.5 hover:border-lilac/50 hover:bg-white/[0.06] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lilac focus-visible:ring-offset-2 focus-visible:ring-offset-card disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:translate-y-0";

export const SocialButtons = () => {
  const [appleEnabled, setAppleEnabled] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API}/api/auth/providers`);
        if (res.ok) {
          const data = await res.json();
          setAppleEnabled(Boolean(data.apple));
        }
      } catch {
        /* providers stay at their defaults */
      }
    })();
  }, []);

  const continueWithGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/account";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const continueWithApple = () => {
    window.location.assign(`${API}/api/auth/apple/start`);
  };

  return (
    <div data-testid="social-signin" className="space-y-3">
      <button type="button" data-testid="google-signin-button" onClick={continueWithGoogle} className={socialButtonClass}>
        <GoogleMark />
        Continue with Google
      </button>
      <button
        type="button"
        data-testid="apple-signin-button"
        onClick={continueWithApple}
        disabled={!appleEnabled}
        aria-describedby={appleEnabled ? undefined : "apple-signin-note"}
        className={socialButtonClass}
      >
        <AppleMark />
        Continue with Apple
      </button>
      {!appleEnabled && (
        <p id="apple-signin-note" data-testid="apple-signin-note" className="text-center text-xs text-paper/40">
          Apple sign-in is being set up — use Google or email for now.
        </p>
      )}
    </div>
  );
};
